import { useAuth } from '../context/AuthContext';

/**
 * Returns the role-aware base path for navigation.
 * Agent pages are reused by counselors — this hook ensures
 * internal navigate() calls go to /counselor/... or /agent/... as appropriate.
 */
export function useRoleBasePath() {
  const { user } = useAuth();
  return user?.role === 'counselor' ? '/counselor' : '/agent';
}
